/**
 * LD.CLPBP.Public.Service
 * No descripton provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

'use strict';
import * as models from './models';

export interface LDCLPBPPublicApiModelsDashboardGetDashboardBorrowerFacts {
    

    borrowerID?: string;

    firstName?: string;

    lastName?: string;

    dob?: Date;

    email?: string;

    code?: string;

    openTasks?: number;

    position?: LDCLPBPPublicApiModelsDashboardGetDashboardBorrowerFacts.PositionEnum;

    isLoggedInBorrower?: boolean;

    reEntryState?: LDCLPBPPublicApiModelsDashboardGetDashboardBorrowerFacts.ReEntryStateEnum;
}
export namespace LDCLPBPPublicApiModelsDashboardGetDashboardBorrowerFacts {

    export enum PositionEnum { 
        Primary = <any> 'Primary',
        CoBorrower = <any> 'CoBorrower',
    }

    export enum ReEntryStateEnum { 
        Unknown = <any> 'Unknown',
        Register = <any> 'Register',
        Property = <any> 'Property',
        About = <any> 'About',
        Identity = <any> 'Identity',
        Income = <any> 'Income',
        Assets = <any> 'Assets',
        Spouse = <any> 'Spouse',
        Submit = <any> 'Submit',
        Offers = <any> 'Offers',
        SelfService = <any> 'SelfService',
        Completed = <any> 'Completed',
    }
}
